import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region ../icons/dist/react/minimal/speech.js
const SpeechIcon = (props, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	fill: "currentColor",
	"aria-hidden": "true",
	viewBox: "0 0 18 18",
	ref,
	...props,
	children: [/* @__PURE__ */ jsx("path", {
		fillOpacity: .2,
		stroke: "currentColor",
		strokeWidth: 1.5,
		d: "M6 12.75a4.25 4.25 0 0 1 3.835 2.417c.008.016.005.017.006.009 0-.006.001-.003-.007.009a.2.2 0 0 1-.158.065H2.324a.2.2 0 0 1-.158-.065c-.009-.012-.007-.015-.006-.01 0 .01-.003.008.005-.008a4.25 4.25 0 0 1 3.521-2.405zm0-6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
	}), /* @__PURE__ */ jsx("path", { d: "M14 2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1.333L10.8 8.4A.5.5 0 0 1 10 8V6.73A2 2 0 0 1 9 5V4a2 2 0 0 1 2-2zm-2.75 1.5a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75z" })]
});
const ForwardRef = forwardRef(SpeechIcon);
//#endregion
export { ForwardRef as default };

//# sourceMappingURL=speech.js.map